import React from 'react'
import { Container } from '@olxbr/ds-web'
import { getAccount, getWallet } from '../../../api'
import {
  LevelProgress,
  LevelProgressSkeleton,
  LevelSteps,
  LevelStepsSkeleton,
} from '../../organisms'

export class AccountLevelPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      hasWallet: false,
      emailVerified: false,
      phoneVerified: false,
      email: '',
      publicAccountId: '',
    }
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = () =>
    Promise.allSettled([getAccount(), getWallet()])
      .then(([accountPromise, walletPromise]) =>
        this.setState({
          emailVerified: accountPromise.value?.emailVerified,
          phoneVerified: accountPromise.value?.phoneVerified,
          hasWallet: walletPromise.value?.data?.status === 'ACTIVE',
          email: accountPromise.value?.email,
          publicAccountId: accountPromise.value?.publicAccountId,
        })
      )
      .catch(() => null)
      .finally(() => this.setState({ loading: false }))

  render() {
    const profileCreated = true // Always true, so we start the level progress from 1.
    const { email, publicAccountId, loading, emailVerified, phoneVerified, hasWallet } = this.state
    const tasks = [profileCreated, emailVerified, phoneVerified, hasWallet]
    const tasksCompleted = tasks.filter(task => task).length

    return (
      <div className="flex flex-col">
        <span className="typo-title-large mb-1">Nível da conta</span>
        <span className="typo-subtitle-medium text-neutral-120 mb-4">
          Torne sua conta mais segura e seu perfil mais confiável.
        </span>
        <div className="flex flex-col">
          <Container
            type="outlined"
            flexDirection="column"
            alignItems="stretch"
            marginBottom="--spacing-3"
          >
            {loading ? (
              <LevelProgressSkeleton />
            ) : (
              <LevelProgress
                steps={tasks.length}
                stepsCompleted={tasksCompleted}
                publicAccountId={publicAccountId}
              />
            )}
          </Container>
          <Container type="outlined" flexDirection="column" alignItems="stretch">
            {loading ? (
              <LevelStepsSkeleton />
            ) : (
              <LevelSteps
                email={email}
                emailVerified={emailVerified}
                phoneVerified={phoneVerified}
                hasWallet={hasWallet}
                profileCreated={profileCreated}
              />
            )}
          </Container>
        </div>
      </div>
    )
  }
}
